<template>
  <div class="layout">
    <div class="box-titulo">Reporte de Ventas por Horas</div>

    <table width="100%">
      <tbody>
        <tr>
          <td width="150px">
            <input
              id="fecha"
              placeholder="Fecha inicio"
              datatype="fecha"
              type="text"
              class="form-control"
              autocomplete="off"
              v-on:change="trigger()"
            />
          </td>
          <td width="150px">
            <input
              id="fechafinal"
              placeholder="Fecha final"
              datatype="fecha"
              type="text"
              class="form-control"
              autocomplete="off"
              v-on:change="trigger()"
            />
          </td>
          <td>
            <button
              @click="consultar"
              class="btn btn-primary"
            >
              Consultar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Filtro de fecha -->

    <div ref="chartContainer" class="w-full h-96"></div>

    <div class="boton_layaout">
      <button
        class="btn btn-success text-right"
        type="submit"
        v-on:click="sendToExcel"
      >
        Exportar
      </button>
    </div>
    <div class="table-layaout">
      <div id="reporte">
        <table class="table-auto w-full mt-6 border">
          <thead class="bg-gray-100">
            <tr>
              <th class="p-2 border">Hora</th>
              <th class="p-2 border">Total ($)</th>
              <th class="p-2 border">% del Total</th>
              <th class="p-2 border">Volumen</th>
              <th class="p-2 border">% del Volumen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in ventasPorHora" :key="index">
              <td class="p-2 border text-right">{{ row.hora }}</td>
              <td class="p-2 border text-right">
                {{ row.total.toLocaleString() }}
              </td>
              <td class="p-2 border text-right">
                {{ row.porcentajeTotal.toFixed(1) }}%
              </td>
              <td class="p-2 border">{{ row.volumen.toFixed(2) }}</td>
              <td class="p-2 border text-right">
                {{ row.porcentajeVolumen.toFixed(1) }}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import axios from "axios";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";

export default {
  name: "VentasPorHora",
  data() {
    return {
      ventasPorHora: [],
      categorias: Array.from(
        { length: 24 },
        (_, i) => i.toString().padStart(2, "0") + ":00"
      ),
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
  },
  mounted() {
    var fecha = new Date();
    $("#fecha").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate())
    );
    $("#fechafinal").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate())
    );
    $("input[datatype='fecha']").datepicker();
    this.renderChart();
    this.cargarVentasPorHora();
  },
  methods: {
    async consultar() {
      this.cargarVentasPorHora();
    },
    async cargarVentasPorHora() {
      try {
        var fecha = $("#fecha").val();
         var fechafinal = $("#fechafinal").val();
        const response = await axios.get(GLOBAL.API_GET_REPORTE_VENTAS_HORAS, {
          params: {
            fecha: fecha, 
            fechafinal: fechafinal, 
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Basic " + this.person.token,
            Environment: this.person.empresas,
          },
        });

        const data = response.data;

        if (!Array.isArray(data)) {
          console.warn("Respuesta inesperada del servidor:", data);
          return;
        }

        const totalSuma = data.reduce((sum, row) => sum + row.total, 0);
        const volumenSuma = data.reduce((sum, row) => sum + row.volumen, 0);

        this.ventasPorHora = data.map((row) => ({
          ...row,
          porcentajeTotal: totalSuma ? (row.total / totalSuma) * 100 : 0,
          porcentajeVolumen: volumenSuma
            ? (row.volumen / volumenSuma) * 100
            : 0,
        }));

        this.renderChart(this.ventasPorHora);
      } catch (error) {
        console.error("Error al cargar ventas por hora:", error);
      }
    },
    renderChart(data) {
      if (!Array.isArray(data)) return;

      Highcharts.chart(this.$refs.chartContainer, {
        chart: { type: "column" },
        title: { text: "Ventas por hora" },
        credits: { enabled: false },
        xAxis: {
          categories: data.map((v) => v.hora),
        },
        yAxis: {
          title: { text: "Monto / Volumen" },
          labels: {
            formatter: function () {
              return this.value.toFixed(2);
            },
          },
        },
        tooltip: {
          formatter: function () {
            return `<b>${this.series.name}</b><br/>Hora: ${
              this.x
            }<br/>Valor: ${this.y.toFixed(2)}`;
          },
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
              formatter: function () {
                return this.y.toFixed(2);
              },
            },
          },
        },
        series: [
          {
            name: "Volumen",
            data: data.map((v) => parseFloat(v.volumen)),
          },
          {
            name: "Total ($)",
            data: data.map((v) => parseFloat(v.total)),
          },
        ],
        exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              menuItems: [
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
                "separator",
                "downloadCSV",
                "downloadXLS",
                "openInCloud",
              ],
            },
          },
        },
      });
    },
    sendToExcel() {
      // Obtener el contenido HTML de la tabla
      const tableHTML = document.querySelector("#reporte").outerHTML;

      // Endpoint de la API
      const url = GLOBAL.API_SEND_HTML_EXCEL;

      // Definir el nombre del archivo
      const fileName = "reporte_ventas_horas.xlsx"; // Puedes generar dinámicamente el nombre aquí

      // Realizar la solicitud POST
      axios
        .post(url, tableHTML, {
          responseType: "blob", // Importante para manejar archivos binarios
          headers: {
            "Content-Type": "text/html", // Enviar como HTML
            "Access-Control-Allow-Origin": "*",
            Authorization: "Basic " + this.person.token, // Incluye tu token si es necesario
            Environment: this.person.empresas, // Otros encabezados necesarios
            "File-Name": fileName, // Encabezado personalizado con el nombre del archivo
          },
        })
        .then((response) => {
          // Crear un enlace para descargar el archivo
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName; // Usar el mismo nombre aquí
          link.click();
          window.URL.revokeObjectURL(link.href); // Limpiar la URL del objeto
        })
        .catch((error) => {
          console.error("Error al generar el archivo Excel:", error);
        });
    },
  },
};
</script>

<style scoped>
/* Contenedor centrado */
.boton_layaout {
  width: 500px;
  text-align: right;
  margin: auto;
  background-color: #e5e7eb;
  margin-top: 20px;
  padding: 10px;
}
.table-layaout {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.table-auto {
  border-collapse: collapse;
  width: 100%;
  max-width: 500px; /* Ancho máximo de 500px */
  margin: 0 auto; /* Centrado horizontal */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
}

.table-auto th,
.table-auto td {
  border: 1px solid #e5e7eb; /* gray-200 */
  padding: 0.75rem;
  text-align: right;
}

.table-auto th {
  background-color: #f9fafb; /* gray-50 */
  font-weight: 600;
  text-align: center;
  color: #111827; /* gray-900 */
}

.table-auto td {
  background-color: #ffffff;
  color: #374151; /* gray-700 */
}

.table-auto tbody tr:nth-child(even) {
  background-color: #f3f4f6; /* gray-100 */
}

.table-auto tbody tr:hover {
  background-color: #e0f2fe; /* blue-100 */
  transition: background-color 0.3s ease;
}

/* Alineación de la primera columna (hora) al centro */
.table-auto td:first-child,
.table-auto th:first-child {
  text-align: center;
}

/* Alineación de números a la derecha para las columnas restantes */
.table-auto td:not(:first-child),
.table-auto th:not(:first-child) {
  text-align: right;
}
</style>
